@@ -0,0 +1,308 @@
<template>
  <div id="student-meal-list" class=" ">
    <div class="container admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">{{ lang('Student Meal Report') }}</h3>
        </div>
        <div class="col-lg-7">
          <div class="row searchingArea" style="margin-bottom: 5px">
            <el-select
              v-model="ddlSemester"
              :placeholder="lang('Select Semester')"
              class="pro-edt-select"
              @change="loadLevelSemDBySemesterID()"
              style="margin-left: auto !important"
            >
              <el-option v-for="item in ddlSemesterList" :key="item.PK_Semester_ID" :label="item.SMT_Code" :value="item.PK_Semester_ID"> </el-option>
            </el-select>
          </div>
          <div class="row searchingArea" style="margin-bottom: 5px">
            <el-select v-model="ddlLevel" :placeholder="lang('Select Level')" @change="loadClass()" class="pro-edt-select" style="margin-left: auto !important">
              <el-option v-for="item in ddlLevelList" :key="item.PK_Course_ID" :label="item.CRS_Course_Name" :value="item.PK_Course_ID"> </el-option>
            </el-select>
          </div>
          <!-- div class="row searchingArea" style="margin-bottom:5px;"> 
                    <el-select placeholder="Select Class" v-model="ddlClass"
                                class="pro-edt-select"
                                style="margin-left: auto!important;">
                        <el-option
                                v-for="item in ddlClassList"
                                :label="item.CLS_ClassName+'-'+item.CLS_Batch"
                                :value="item.PK_Class_ID"
                        >
                        </el-option>
                    </el-select>
                </div-->
          <div class="row searchingArea" style="margin-bottom: 5px">
            <el-select v-model="ddlTerm" :placeholder="lang('Select Term')" class="pro-edt-select" style="margin-left: auto !important">
              <el-option v-for="item in ddlTermList" :key="item.PK_SEMD_ID" :label="item.SEMD_DetailName" :value="item.PK_SEMD_ID"> </el-option>
            </el-select>
          </div>
          <div class="row searchingArea" style="margin-bottom: 5px">
            <button class="btn btn-primary searchbtn" id="btnSearch" v-on:click="Search()">Search</button>
          </div>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="studentList.length < 1">
          <strong v-if="hideStudentList === false">
            {{ lang('Please select Level...') }}
          </strong>
          <strong v-if="hideStudentList === true">
            {{ lang('No Student Found...') }}
          </strong>
          <img src="../assets/attendance.jpg" />
        </div>
        <div v-if="studentList.length > 0" class="responsive-table">
          <el-button size="small" type="primary" icon="el-icon-download" v-on:click="DownloadExcel()" class="pull-left mb-3">Download </el-button>
          <div class="divSortBy">
            <label>Sort By</label>
            <el-select v-model="sortOptionsSelected" @change="changeSort()" placeholder="Sort By" class="pro-edt-select">
              <el-option v-for="item in sortOptions" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <table class="attTable">
            <tr>
              <th>{{ lang('Student No') }}</th>
              <th>{{ lang('Student Name') }}</th>
              <th>{{ lang('Class') }}</th>
              <th>{{ lang('Status') }}</th>
              <th>{{ lang('Remarks') }}</th>
              <th>{{ lang('Food Allergens') }}</th>
              <th>{{ lang('Start Date') }}</th>
              <th>{{ lang('End Date') }}</th>
            </tr>
            <tr v-for="record in studentList" v-bind:key="record.Student_ID">
              <td>{{ record.Index_No }}</td>
              <td>
                <a target="_blank" :href="'/student?id=' + record.Student_ID">{{ record.student_name }}</a>
              </td>
              <td>{{ record.Class_Name }}</td>
              <td>{{ record.SML_Status }}</td>
              <td>{{ record.Student_Remarks }}</td>
              <td>{{ record.Allergens }}</td>
              <td>{{ moment(record.SML_From_Date).format('DD MMM YYYY') }}</td>
              <td>{{ moment(record.SML_To_Date).format('DD MMM YYYY') }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import moment from 'moment'
import { lang } from '../locale/index'
import GlobalFn from '../components/GlobalFn'
import Cookies from 'js-cookie'
import XLSX from 'xlsx'

export default {
  name: 'StudentMealReport',
  data() {
    return {
      checkListSelect: ['Present', 'Absent', 'Late', 'Sick', 'On Holiday', 'Sent Home'],
      ddlLevelList: [],
      ddlLevel: '',
      ddlSemesterList: [],
      ddlSemester: '',
      ddlTermList: [],
      ddlTerm: '',
      ddlStudent: '',
      ddlClassList: [],
      ddlClass: '',
      studentList: [],
      studentClass: [],
      studentCheck: [],
      selectedStudent: [],
      selectallStudent: false,
      bundleAttendance: false,
      hideStudentList: false,
      tempDeviceOutput: '',
      sortOptionsSelected: '',
      sortOptions: ['Student Name (ASC)', 'Student Name (DESC)', 'Start Date(ASC)', 'Start Date(DESC)', 'End Date(ASC)', 'End Date(DESC)'],
      selectedDate: '',
      schID: '',
      inputAdvanceClassAttendanceFromToDatePickerOptions: {
        disabledDate(time) {
          var today = new Date()
          var yesterday = new Date()
          yesterday.setDate(today.getDate() - 2)
          return !(time <= today && yesterday <= time)
        },
      },
    }
  },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.bindSemesters()
  },
  async mounted() {},
  computed: {},
  components: {
    GlobalFn,
  },
  methods: {
    lang,
    async loadClass() {
      try {
        this.ddlClassList = []
        const response = await DataSource.shared.getClassBySemesterAndCourseID(this.ddlSemester, this.ddlLevel)
        response.Table.forEach(m => {
          this.ddlClassList.push(m)
        })
      } catch (e) {
        this.results = e
      }
    },
    async loadLevelSemDBySemesterID() {
      try {
        const respLev = await DataSource.shared.getCourseBySemesterID(this.schID, this.ddlSemester)
        if (respLev) {
          this.ddlLevelList = []
          respLev.Table.forEach(m => {
            this.ddlLevelList.push(m)
          })
        }
        const respSem = await DataSource.shared.getSemesterTermDetailsBySemID(this.ddlSemester, '', 'Active')
        if (respSem) {
          this.ddlTermList = []
          respSem.Table.forEach(m => {
            this.ddlTermList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async bindSemesters() {
      try {
        const response = await DataSource.shared.getAcademicYearBySchoolID(this.schoolID)

        if (response) {
          response.Table.forEach(m => {
            this.ddlSemesterList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async Search() {
      this.$vs.loading()
      this.studentList = []
      const response = await DataSource.shared.LoadStudentMealList(this.schID, this.ddlSemester, this.ddlLevel, this.ddlTerm, this.ddlClass)
      if (response) {
        if (response.code === '2') {
          this.studentList = []
          this.hideStudentList = true
        } else if (response.code === '99') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Error! Please try again later'),
          })
        } else {
          this.studentList = response.Table1
        }
      }
      this.$vs.loading.close()
    },

    changeSort() {
      //sortOptions: ['Student Name (ASC)','Student Name (DESC)','Start Date(ASC)','Start Date(DESC)','End Date(ASC)','End Date(DESC)'],
      if (this.sortOptionsSelected === 'Student Name (ASC)') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'student_name', 'asc')
      }
      if (this.sortOptionsSelected === 'Student Name (DESC)') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'student_name', 'desc')
      }
      if (this.sortOptionsSelected === 'Start Date(ASC)') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'SML_From_Date', 'asc')
      }
      if (this.sortOptionsSelected === 'Start Date(DESC)') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'SML_From_Date', 'desc')
      }
      if (this.sortOptionsSelected === 'End Date(ASC)') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'SML_To_Date', 'asc')
      }
      if (this.sortOptionsSelected === 'End Date(DESC)') {
        this.studentList = GlobalFn.SortObjectByKey(this.studentList, 'SML_To_Date', 'desc')
      }
    },

    DownloadExcel() {
      let exportFPSExcelObject = []
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      this.studentList.forEach(m => {
        let tempList = {
          'Student No': m.Index_No,
          'Student Name': m.student_name,
          Class: m.Class_Name,
          Status: m.SML_Status,
          Remarks: m.Student_Remarks,
          'Food Allergens': m.Allergens,
          'Start Date': moment(m.SML_From_Date).format('DD MMM YYYY'),
          'End Date': moment(m.SML_To_Date).format('DD MMM YYYY'),
        }
        exportFPSExcelObject.push(tempList)
      })

      var sheet2WS = XLSX.utils.json_to_sheet(exportFPSExcelObject)
      var wb2 = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb2, sheet2WS, 'sheet2') // sheetAName is name of Worksheet
      //XLSX.writeFile(wb2, 'FPS Report - ' + currentDateWithFormat + '.xlsx'); // name of the file is 'book.xlsx'
      XLSX.writeFile(wb2, 'Student Meal Report - ' + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>
<style scoped>
.attTable {
  width: 100%;
  margin-top: 20px;
}

.attTable td,
.attTable th,
.attTable label {
  text-align: center;
  padding: 10px;
}

.attTable tr:nth-child(even) {
  background: #fff;
}

.ddlClass {
  display: inline;
  width: auto;
}

.lblClass {
  display: inline !important;
  padding: 20px;
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 5px;
  border: 2px solid #555;
}

.searchingArea {
  text-align: left;
}

.checkbox_wrapper {
  min-width: 100%;
}

.lblCheckBox {
  width: 100%;
}

.attendance-search .el-select {
  margin-left: 10px !important;
}

.lblStudentName {
  font-weight: normal !important;
}

.divSortBy {
  text-align: right;
}
.divSortBy label {
  display: inline !important;
  margin-right: 10px;
}
</style>
